import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { IFilterProps } from '../../types';
import * as styles from './styles.css';

export const Filter: React.FC<IFilterProps> = ({ children, title }) => {
  return (
    <div className={styles['filter']}>
      <div className={styles['title']}>
        <UIText2>{title}</UIText2>
      </div>
      <div className={styles['wrapper']}>
        <div className={styles['scrollable']}>{children}</div>
      </div>
    </div>
  );
};
